import { action, makeObservable, observable } from 'mobx';

class OrderStore {
    constructor() {
        makeObservable(this)
    }

    @observable loadingItemStatus: boolean = false;
    @action setLoadingItemStatus(status: boolean) {
        this.loadingItemStatus = status;
    }

    // Order Datas
    @observable orderDatas = {};

    @action addOrderData(orderId: number, orderData: any) {
        this.orderDatas[orderId] = orderData;
    }

    @action updateOrderData(orderId: number, orderData: any) {
        this.orderDatas[orderId] = orderData;
    }
    // Order Datas

    // Orders
    @observable orders = {
        content: {},
        page: 1,
        pageCount: 1,
    }

    @action setOrders(orders: any) {
        this.orders['content'] = orders;
    }

    @action setPaginationData(page: number, pageCount: number) {
        this.orders = {
            ...this.orders,
            page,
            pageCount,
        };
    }

    @action addOrder(orderId: number, orderData: any) {
        this.orders['content'][orderId] = orderData;
    }

    @action updateOrder(orderId: number, orderData: any) {
        if (this.orders['content'][orderId] !== undefined) {
            this.orders['content'][orderId] = orderData;
        }

        if (this.orderDatas[orderId] !== undefined) {
            this.orderDatas[orderId] = orderData;
        }
    }

    @action deleteOrder(orderId: number) {
        delete this.orders['content'][orderId];
    }
    // Orders

    // Search Orders
    @observable searchOrders = {
        content: {},
        page: 1,
        pageCount: 1,
    };

    @action setSearchOrders(searchOrders: any) {
        this.searchOrders = searchOrders;
    }

    @action resetSearchOrders() {
        this.searchOrders = {
            content: {},
            page: 1,
            pageCount: 1,
        };
    }

    @action setSearchPaginationData(page: number, pageCount: number) {
        this.searchOrders = {
            ...this.searchOrders,
            page,
            pageCount,
        };
    }

    @action addSearchOrder(orderId: number, orderData: any) {
        this.searchOrders.content[orderId] = orderData;
    }

    @action deleteSearchOrder(orderId: number) {
        if (this.searchOrders.content[orderId] !== undefined) {
            delete this.searchOrders.content[orderId];
        }
    }

    @observable searchFilterText = "";
    @action setSearchFilterText(filterText: string) {
        this.searchFilterText = filterText;
    }
    // Search Orders
}

const store = new OrderStore();

export default store;